import Swiper, { Navigation, Pagination } from "swiper";

const RelatedProducts = {
  swiperInstance: null, // Store the Swiper instance

  init() {
    const wrapEl = $(".related-products");

    const initializeSwiper = () => {
      const productCount = wrapEl.find(".products-slider .swiper-wrapper")[0]?.children.length;
      const containerEl = $(wrapEl.find(".container")[0]);

      if (!containerEl.length || !wrapEl.length) {
        console.log("Related products container element or wrap element not found");
        return;
      }

      const viewportWidth = $(window).width();
      let activeNavigation;

      if (productCount > 4) {
        activeNavigation = true;
      } else if (productCount > 3 && viewportWidth < 1290) {
        activeNavigation = true;
      } else if (productCount > 2 && viewportWidth < 965) {
        activeNavigation = true;
      } else {
        activeNavigation = productCount > 1 && viewportWidth < 640;
      }

      // Adjust navigation visibility (toggle based on activeNavigation)
      const sliderNav = $(".products-slider__bottom");
      if (sliderNav.length) {
        if (activeNavigation) {
          sliderNav.removeClass("hidden");
        } else {
          sliderNav.addClass("hidden");
        }
      }

      // Adjust container class based on product count
      $(containerEl).removeClass('container--small container--medium');
      $(containerEl).addClass(
        productCount <= 2 ? "container--small" :
          productCount === 3 ? "container--medium" : ""
      );

      // Ensure all swiper-related elements exist before initializing Swiper
      const productsSliderEl = wrapEl.find(".products-slider")[0];
      const paginationEl = wrapEl.find(".swiper-pagination")[0];
      const prevButtonEl = wrapEl.find(".swiper-button-prev")[0];
      const nextButtonEl = wrapEl.find(".swiper-button-next")[0];

      if (!productsSliderEl) {
        console.error("Products slider element not found");
        return;
      }

      // Destroy existing Swiper instance before initializing a new one
      if (RelatedProducts.swiperInstance && !RelatedProducts.swiperInstance.destroyed) {
        try {
          RelatedProducts.swiperInstance.destroy(true, true); // Destroy and remove all events
        } catch (error) {
          console.error("Error destroying Swiper instance:", error);
        }
      }

      // Initialize Swiper with activeNavigation condition
      RelatedProducts.swiperInstance = new Swiper(productsSliderEl, {
        modules: [Pagination, Navigation],
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: activeNavigation && paginationEl ? {
          el: paginationEl,
          bulletElement: "button",
          dynamicBullets: true,
          dynamicMainBullets: 1,
          clickable: true,
        } : false, // Disable pagination if activeNavigation is false or element is missing
        navigation: activeNavigation && prevButtonEl && nextButtonEl ? {
          prevEl: prevButtonEl,
          nextEl: nextButtonEl,
        } : false, // Disable navigation if activeNavigation is false or buttons are missing
        breakpoints: {
          1200: {
            slidesPerGroup: 4,
          },
        },
      });
    };

    // Initial call to setup the swiper
    initializeSwiper();

    // Handle viewport resizing and reinitialize Swiper
    $(window).on('resize', function () {
      initializeSwiper();
    });
  }
}

export default RelatedProducts;
